import { useState, type FormEvent } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../api/client'
import { PageShell } from '../components/BrandChrome'
import { Alert, Button, Card, Input, Label, Subtitle, Title } from '../components/ui'
import { errorMessage } from '../lib/format'

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [sent, setSent] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setBusy(true)
    try {
      await api.forgotPassword(email.trim())
      setSent(true)
    } catch (err) {
      setError(errorMessage(err))
    } finally {
      setBusy(false)
    }
  }

  return (
    <PageShell homeTo="/login">
      <Card className="mx-auto max-w-md">
        <Title>Forgot password</Title>
        <Subtitle>We will email a reset link if that account exists.</Subtitle>
        {sent ? (
          <div className="space-y-4">
            <Alert tone="success">
              If an account exists for that email, a reset link is on the way. Check your inbox
              (and spam), then return here to sign in after resetting.
            </Alert>
            <p className="text-center text-sm">
              <Link to="/login">Back to sign in</Link>
            </p>
          </div>
        ) : (
          <form className="space-y-4" onSubmit={onSubmit}>
            {error ? <Alert>{error}</Alert> : null}
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                name="email"
                type="email"
                autoComplete="username"
                required
                value={email}
                onChange={(ev) => setEmail(ev.target.value)}
              />
            </div>
            <Button type="submit" disabled={busy} className="w-full">
              {busy ? 'Sending…' : 'Send reset link'}
            </Button>
            <p className="text-center text-sm text-slate-600">
              <Link to="/login">Back to sign in</Link>
            </p>
          </form>
        )}
      </Card>
    </PageShell>
  )
}
